import type { AdminNamespace } from '@cli-types/next-adapter/config.js'
import { DEFAULT_ADMIN_NAMESPACE } from '@cli-constants/scaffolding.js'

export function protectExistingNamespaceLiterals(
  value: string,
  namespace: AdminNamespace
): {
  value: string
  restore: (output: string) => string
} {
  if (namespace.segment === DEFAULT_ADMIN_NAMESPACE) {
    return {
      value,
      restore(output: string): string {
        return output
      }
    }
  }

  const literals = Array.from(
    new Set([
      namespace.alias,
      namespace.apiPath,
      namespace.routePath,
      namespace.routeGroup,
      namespace.cssRootClass,
      namespace.globalsFile,
      `${namespace.segment}/`,
      `${namespace.segment}-`,
      namespace.screaming,
      namespace.pascal,
      namespace.camel
    ])
  ).sort((a, b) => b.length - a.length)

  const replacements: Array<[string, string]> = []
  let protectedValue = value

  for (const [index, literal] of literals.entries()) {
    if (!protectedValue.includes(literal)) {
      continue
    }

    const token = `__BSTART_NS_${index}__`
    protectedValue = protectedValue.replaceAll(literal, token)
    replacements.push([token, literal])
  }

  return {
    value: protectedValue,
    restore(output: string): string {
      let restored = output
      for (const [token, literal] of replacements) {
        restored = restored.replaceAll(token, literal)
      }
      return restored
    }
  }
}
